"use client";
/**
 * SANATAN DECODE — गोत्र, Episode 1.  v19 — hand-authored at v9 density.
 *
 * v18 was rejected as "worse than a 2005 powerpoint". The measurable cause: v9 carries ~38 lines
 * of authoring per second of video, v18 carried 0.8. Same assets, same timing, 45× less craft.
 * v19 authors every beat by hand against real word indices — type lands word by word, objects
 * travel and rescale instead of being re-introduced, and every cut carries a light sweep.
 *
 * ACT 1 (this build) = beats 0-4, 0:00-1:18. Acts 2-5 follow the same pattern.
 */
import React from "react";
import { AbsoluteFill, Audio, Img, staticFile, interpolate, Easing, useVideoConfig } from "remotion";
import { useStep, useF, Halftone, Grain, Petals, AuditProbe } from "./sanatan/craft";
import { Beat0, Beat1, Beat2, Beat3, Beat4, ActRishi, SystemPair } from "./sanatan/gotraAct1";

/* ══ GROUND — held still, travels only across a cut (§8b rule 6) ══ */
const PANO_W = 3840, PANO_H = 1280, DISPLAY_H = 980;
const STOPS: [number, number, number][] = [   // [second, panoIndex, x fraction]
  [0.0, 0, 0.00], [15.6, 0, 0.00],
  [15.9, 0, 0.10], [29.5, 0, 0.10],
  [29.9, 0, 0.22], [42.9, 0, 0.22],
  [43.3, 0, 0.36], [61.0, 0, 0.36],
  [61.4, 1, 0.00], [78.0, 1, 0.14],
];
const PANOS = ["gurukul_pano", "pano_sabha", "modern_pano", "pano_courtroom"];

const Ground: React.FC = () => {
  const frame = useStep(); const F = useF();
  const dispW = (PANO_W / PANO_H) * DISPLAY_H, travel = dispW - 1280;
  const ts = STOPS.map((s) => F(s[0]));
  for (let i = 1; i < ts.length; i++) if (ts[i] <= ts[i - 1]) ts[i] = ts[i - 1] + 0.5;
  const x = interpolate(frame, ts, STOPS.map((s) => s[2]), {
    extrapolateLeft: "clamp", extrapolateRight: "clamp", easing: Easing.inOut(Easing.cubic),
  });
  let gi = 0;
  for (const s of STOPS) if (frame >= F(s[0])) gi = s[1];
  return (
    <AbsoluteFill style={{ backgroundColor: "#F2E6CC", overflow: "hidden", zIndex: 0 }}>
      <Img src={staticFile(`sanatan/pano/${PANOS[gi]}.png`)} style={{
        position: "absolute", height: DISPLAY_H, width: dispW, left: -x * travel, top: -150,
        maxWidth: "none", filter: "blur(4.8px) saturate(0.56) brightness(1.16) contrast(0.80)",
      }} />
      <AbsoluteFill style={{ backgroundColor: "rgba(249,240,222,0.44)" }} />
      <AbsoluteFill style={{ background: "radial-gradient(ellipse 86% 80% at 46% 48%, rgba(255,252,242,0.38) 0%, rgba(198,158,100,0.34) 100%)" }} />
    </AbsoluteFill>
  );
};

/* ══ DYNAMIC FACTOR — author once at 1280×720, ship any size ══ */
const AW = 1280, AH = 720;
const Stage: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { width, height } = useVideoConfig();
  const k = Math.max(width / AW, height / AH);
  return (
    <AbsoluteFill style={{ backgroundColor: "#F2E6CC", overflow: "hidden" }}>
      <div style={{ position: "absolute", width: AW, height: AH, left: (width - AW * k) / 2, top: (height - AH * k) / 2, transform: `scale(${k})`, transformOrigin: "0 0" }}>
        {children}
      </div>
    </AbsoluteFill>
  );
};

export const SanatanDecodeGotraV19: React.FC = () => <Stage><Film /></Stage>;

const Film: React.FC = () => (
  <AbsoluteFill style={{ backgroundColor: "#F2E6CC" }}>
    <Audio src={staticFile("sanatan/audio/gotra_ep01.mp3")} />
    <Ground />
    <Beat0 /><Beat1 /><Beat2 /><Beat3 /><Beat4 />
    <SystemPair />
    <ActRishi />
    <AuditProbe />
    <Petals n={10} op={0.16} />
    <Halftone op={0.08} />
    <Grain op={0.11} />
  </AbsoluteFill>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
